import {
  ADD_SALES_RETURN_LINE_DETAILS,
  UPDATE_SALES_RETURN_LINE_DETAILS,
  GET_SALES_RETURN_LINE_DETAILS,
  GET_SALES_RETURN_LINE_DETAIL,
  DELETE_SALES_RETURN_LINE_DETAILS,
} from '../types';

const initialState = {
  list: [],
  single: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SALES_RETURN_LINE_DETAILS:
      return { ...state, list: [...state.list, action.payload] };
    case UPDATE_SALES_RETURN_LINE_DETAILS:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === action.payload.id ? { ...item, ...action.payload } : item,
        ),
      };
    case GET_SALES_RETURN_LINE_DETAILS:
      return { ...state, list: action.payload };
    case GET_SALES_RETURN_LINE_DETAIL:
      return { ...state, single: action.payload };
    case DELETE_SALES_RETURN_LINE_DETAILS:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== action.payload.id),
      };
    default:
      return state;
  }
};

export default reducer;
